import i18n from "i18next";
import * as Yup from "yup";

// Lithuanian RC unique number: XXXX-XXXX-XXXX with optional :XXXX premises suffix
export const UNIQUE_NR_REGEX = /^\d{4}-\d{4}-\d{4}(:\d{4})?$/;

export const getUniqueNrSchema = () =>
  Yup.string()
    .trim()
    .matches(UNIQUE_NR_REGEX, () => i18n.t("validation.uniqueNrFormat"))
    .required();

export const modifyErrorText = (error: string, label?: string) => {
  if (
    error.includes("required") ||
    error.includes("cast from the value `NaN`")
  ) {
    return i18n.t("validation.fieldRequired", { field: label });
  } else if (error.includes("invalid")) {
    return i18n.t("validation.fieldInvalid", { field: label });
  }
  return error;
};

export const getMinErrorText = (label: string, min: number) => {
  return i18n.t("validation.fieldMin", { field: label, min });
};

export const getMaxErrorText = (label: string, max: number) => {
  return i18n.t("validation.fieldMax", { field: label, max });
};
